// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csln-tab-container {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
  }
  
  .solutions-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  
  .add-criteria-button {
    background-color: blue;
    color: white;
    padding: 5px 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .add-criteria-button:hover {
    background-color: #5a7ce8;
  }
  
  .criteria-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    width: 70%;
    padding: 20px;
    z-index: 1000; 
  }

  
  .form-row {
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
  }
  
  .submit-button {
    background-color: blue;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .submit-button:disabled {
    background-color: gray;
    cursor: not-allowed;
  }

  .dropdown-popup {
    width: 100%;
    height: 32px;
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/assets/CertifiedSolutionDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;;EAGA;IACE,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,aAAa;EACf;;;EAGA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd","sourcesContent":[".csln-tab-container {\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n  }\n  \n  .solutions-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n  }\n  \n  \n  .add-criteria-button {\n    background-color: blue;\n    color: white;\n    padding: 5px 10px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .add-criteria-button:hover {\n    background-color: #5a7ce8;\n  }\n  \n  .criteria-popup {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    width: 70%;\n    padding: 20px;\n    z-index: 1000; \n  }\n\n  \n  .form-row {\n    margin-bottom: 10px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .submit-button {\n    background-color: blue;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .submit-button:disabled {\n    background-color: gray;\n    cursor: not-allowed;\n  }\n\n  .dropdown-popup {\n    width: 100%;\n    height: 32px;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
